import queryString from 'query-string';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import useProfessional from 'src/Professional/hooks/useProfessional';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import { filterSearchSelectedState } from 'src/SearchHours/state/atoms';
import { decryptString } from 'src/shared/global/cryptoJSUtilities';

const MedicoAgendaDirecta = () => {
    const query = queryString.parse(window.location.search, { decode: false })
    const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
    const { loadDaysAvailableAndDefault } = useSearchHours();
    const { loadDetailProfessional } = useProfessional();

    useEffect(() => {
        (async function () {
            if (query.qrp && query.qrp !== "") {
                const rutDecode = decryptString(query.qrp);
                // let rutDecode = decryptString(query.qrp);
                // rutDecode = rutDecode.trim();
                console.log("rutDecode =>", rutDecode );
                const professional = await loadDetailProfessional(rutDecode);
                console.log("professional => ", professional );

                if (professional && professional.length > 0) {
                    setFilterSearchSelected((current) => ({
                        ...current,
                        specialitySelected: {
                            code: null,
                            value: null
                        },
                        professionalSelected: {
                            ...current.professionalSelected,
                            code: professional[0].ptdRut,
                            value: professional[0].ptdNombre
                        }
                    }))

                    setTimeout(() => {
                        loadDaysAvailableAndDefault()
                    }, 0)
                }
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null;
}

export default MedicoAgendaDirecta